import { type AnalyticsEvent } from './common';

export type AnalyticsEventDef = Omit<AnalyticsEvent, 'properties'>;

/**
 * Auth
 */
export const LOGIN: AnalyticsEventDef = {
  // PROPOSED RENAME: login
  // DEPRECATED: user-demo-login
  name: 'user-login',
  trackIntercom: true,
  trackMixpanel: true,
};

export const LOGOUT: AnalyticsEventDef = {
  // PROPOSED RENAME: logout
  // DEPRECATED: user-demo-logout
  name: 'user-logout',
  trackIntercom: true,
  trackMixpanel: true,
};

export const LOGIN_SESSION: AnalyticsEventDef = {
  name: 'session-login',
  trackIntercom: false,
  trackMixpanel: true,
};

/** Triggered impersonator confirms reason */
export const IMPERSONATION_REASON: AnalyticsEventDef = {
  name: 'impersonation-reason',
  trackIntercom: false,
  trackMixpanel: true,
};

export const EXTERNAL_LINK_LOAD: AnalyticsEventDef = {
  name: 'load-from-external-link',
  trackIntercom: true,
  trackMixpanel: true,
};

/** Triggered when an ErrorBoundary renders an error. */
export const ERROR_BOUNDARY = {
  name: 'vd-error-boundary',
  trackIntercom: true,
  trackMixpanel: true,
};
